export default __webpack_public_path__ + "static/media/p2p-active-m.a51e741d.svg";